<template>
  <div class="fixed bottom-0 left-0 w-full z-50 bg-dark-primary text-white" style="padding-bottom: env(safe-area-inset-bottom)">
    <div class="grid grid-cols-3 h-16 text-base">
      <div ref="homeMenu" class="relative flex">
        <button class="flex-1 flex items-center justify-center" :class="{ [activeClass]: route.name === 'pwa-home' }" @click="menuOpen = !menuOpen">Home</button>
        <div v-if="menuOpen" class="absolute bottom-full left-0 w-40 rounded-tr-lg bg-dark-primary text-white shadow-lg overflow-hidden">
          <button class="block w-full px-4 py-3 text-left" @click="goHome">Home</button>
          <button class="block w-full px-4 py-3 text-left border-t border-white/20" @click="logout">Log out</button>
        </div>
      </div>
      <button
        v-for="tab in tabs"
        :key="tab.key"
        class="flex items-center justify-center"
        :class="{ [activeClass]: tabOf(route.path) === tab.key }"
        @click="openTab(tab.key)"
      >{{ tab.label }}</button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { onClickOutside } from '@vueuse/core';
import { clearSavedCompanies } from '@/utils/savedCompanies';
import { PWA_TABS, lastTabPages, tabOf } from '@/utils/pwa';

const store = useStore()
const route = useRoute()
const router = useRouter()

const activeClass = 'border-t-4 border-white font-semibold'
const menuOpen = ref(false)
const homeMenu = ref(null)
onClickOutside(homeMenu, () => { menuOpen.value = false })

const tabs = [
  { key: 'companies', label: 'Companies' },
  { key: 'contacts', label: 'Contacts' },
]

// Reopens the tab's last page; tapping the tab you're already on goes back to its list
function openTab(tab) {
  const listPath = PWA_TABS[tab]
  const remembered = lastTabPages[tab]
  if (tabOf(route.path) === tab || !remembered) {
    if (route.path !== listPath) router.push(listPath)
    return
  }
  router.push({ path: remembered.path, state: remembered.state })
}

function goHome() {
  menuOpen.value = false
  router.push({ name: 'pwa-home' })
}

async function logout() {
  menuOpen.value = false
  await clearSavedCompanies().catch(error => console.log(error))
  store.dispatch('auth/logout')
  router.push({ name: 'pwa-login' });
}
</script>
